import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPalantirComponent } from './simple-icons-palantir.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPalantirComponent ],
    exports:      [ SimpleIconsPalantirComponent ],
    bootstrap:    []
})
export class SimpleIconsPalantirModule {}
